import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// import { encryptStorage, environment } from '../../environments/environment';
// import { User } from '../models/user';
// import { UserMenuIDAM } from '../models/usermenu.idam';
import { Router, RouterStateSnapshot } from '@angular/router';
import { encryptStorage, environment, MDB_ID } from '../../environments/environment';
import { UserMenuIDAM } from '../../app/auth/model/usermenu.idam';
import { Logout } from '../../app/auth/model/logout';
import { User } from '../../app/auth/model/user';
import { NotificationService } from '../../app/main/shared/notification.service';
import { Result } from 'app/main/shared/result';
// import { Logout } from '../models/logout';


@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;
    public userMenu: any = [];
    public ngMenu: any = [];

    public logoutModel: Logout;
    ipaddres: any;
    public data :any =[];
    public landingPage: string = "";
    constructor(private http: HttpClient,
        private notifyService: NotificationService,

        private router: Router) {
            this.data=[];
         this.data = encryptStorage.getItem('currentUser');
        if (this.data == undefined)
            this.data = null;
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(JSON.stringify(this.data)));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get landingPageValue(): string {
        return this.landingPage;
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    public currentUserRights(path: any): any {
        let rights = [];
        if (this.currentUserSubject.value.menuList.map((x: any) => x.link).indexOf(path) !== -1) {
            rights = this.currentUserSubject.value.menuList.find((x: any) => x.link === path);
        }
        return rights;
    }

    login(userModel: User) {

        // encryptStorage.setItem("clientIp",userModel.clientIp);
        return this.http.post<any>(environment.apiUrl + "/LoginManagement/LoginWithIDAM", userModel)
            .pipe(map(user => {
                if (user.issuccess == true) {
                    console.log(user.data)
                    user = user.data;

                    if (user['landingpageInfo'] != "") {
                        const landingPageInfo = JSON.parse(user['landingpageInfo']);
                        user['landingpageInfo'] = landingPageInfo;
                    }
                    else {
                        user['landingpageInfo'] = ""
                    }

                    let userMenus = JSON.parse(user['userMenu']) as UserMenuIDAM[];

                    let assignedSystemList = [...new Set(userMenus.map(item => item.systemid))];
                    localStorage.setItem('AssignedSystemList', JSON.stringify(assignedSystemList));

                    localStorage.setItem('ALLmenus', JSON.stringify(userMenus));
                    debugger;
                    userMenus = userMenus.filter(x=>x.systemid == MDB_ID);
                    //const userMenus = user['userMenu'] as UserMenu[];

                    let nbMenus = JSON.parse(user['userMenu']) as UserMenuIDAM[];
                    nbMenus = nbMenus.filter(x=>x.systemid == MDB_ID);
                    console.log(nbMenus);

                    var menu = nbMenus.map(x => ({ title: x.title, submenus: x.children.length > 0 ? x.children.map(y => ({ title: y.title, link: y.link })) : [], link: x.link, icon: x.icon.icon, type: (x.children.length > 0 ? 'dropdown' : 'simple') }));
                    localStorage.setItem('menus', JSON.stringify(menu));
                    localStorage.setItem('userData', JSON.stringify(user));

                    //Capture USerID
                    let usr=JSON.parse(JSON.stringify(user));
                    localStorage.setItem('MDBUserID',usr.userId);
                    localStorage.setItem('MDBUserName',usr.loginusername);
                    
                    nbMenus.forEach((x) => {

                        delete x.menuID
                        delete x.parentMenuID
                        delete x.isParentMenu
                        //delete x.permissions
                        delete x.roleName
                        delete x.roleID
                        x.icon = { icon: x.icon, pack: 'myicon' }
                        //x.children.length != 0 ?0 :delete x.children
                        if ("children" in x) {
                            if (x.children.length != 0) {
                                delete x.link
                                x.children.forEach(y => {
                                    delete y.menuID
                                    delete y.parentMenuID
                                    delete y.isParentMenu
                                    //delete y.permissions
                                    delete y.roleName
                                    delete y.roleID
                                    delete y.children
                                });
                            }
                        }
                    });

                    user['userMenu'] = nbMenus;
                    this.userMenu = [];
                    userMenus.forEach((x) => {
                        this.Iteratemenu(x);
                    });

                    user['menuList'] = this.userMenu;
                    //   //user['menuList'] = user['userMenu'];
                    this.currentUserSubject.next(user);

                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    // encryptStorage.setItem('currentUser', JSON.stringify(user));
                    //const value = encryptStorage.getItem('currentUser');
                    
                    encryptStorage.removeItem('currentUser');
                    encryptStorage.setItem('currentUser', JSON.stringify(user));
                    return user;
                }
                else {
                    this.notifyService.showError(user.message, 'Warning');
                    return null;
                }
            }));


    }
    // reset(userModel: User) {
    //     
    //     return this.http.post<any>(environment.apiUrl+"/LoginManagement/ResetPassword", userModel);            
    // }

    public reset(userModel: User) {
        return this.http.post<Result>(environment.apiUrl + "/LoginManagement/ResetPassword", userModel)
            .pipe(map(value => {
                return value;
            }));
    }

    logout() {
        
        localStorage.clear();
        sessionStorage.clear();
        
        this.ipaddres = encryptStorage.getItem("clientIp");
        this.logoutModel = {};
        this.logoutModel.access_Token = this.currentUserSubject.value.token;
        this.logoutModel.refresh_Token = this.currentUserSubject.value.refreshToken;
        this.logoutModel.userid = this.currentUserSubject.value.userId;
        this.logoutModel.clientid = this.currentUserSubject.value.clientId;
        this.logoutModel.login_srno = this.currentUserSubject.value.login_srno;
        this.logoutModel.refNumber = this.currentUserSubject.value.refNumber;
        this.logoutModel.clientIp = this.ipaddres;

        this.http.post<any>(environment.apiUrl + "/LoginManagement/LogoutWithIDAM", this.logoutModel).subscribe(data => {
            //this.postId = data.id;
            if (encryptStorage.getItem('currentUser') != null) {
                encryptStorage.removeItem('currentUser');
                localStorage.removeItem('userData');
                this.currentUserSubject.next(null);
                localStorage.removeItem('menus');
            }
        });

        if (encryptStorage.getItem('currentUser') != null) {
            encryptStorage.removeItem('currentUser');
            
            this.currentUserSubject.next(null);
        }
         encryptStorage.setItem('isReload', 'false');
        this.router.navigate(['/']);
    }

    Iteratemenu(menu: UserMenuIDAM) {
        if (menu.children.length > 0) {
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < menu.children.length; i++) {
                this.Iteratemenu(menu.children[i]);
            }
        } else {

            this.userMenu.push(
                {
                    link: menu.link,
                    title: menu.title,
                    permission: menu.permissions
                });
        }
    }

    public UpdatePassword(data: any) {
        return this.http.post<any>(environment.apiUrl + "/LoginManagement/UpdatePassword", data)
            .pipe(map(user => {

                return user;
            }));
    }

    public GetUserStationDetailsByName(data: any){
        // console.log(data);

        return this.http.post<any>(environment.OPRSAPIUrl+"/Login/GetUserStationDetailsByName", data);
      }

}
